import { Navigate } from "react-router-dom";

const Home = () => {
  return <Navigate to="/billing" replace />;
};

export default Home;
